<template>
    <!-- 팝업 -->
    <div class="pop_up_layer find_account" style="display: block" @click="closeModal"></div>
    <div class="pop_up pop_detail" id="find_account" style="display: block">
        <button class="close_btn" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>

        <template style="display: block">
            <div class="pop_tit">
                <p>물품 출입</p>
            </div>

            <div class="content_wrap">
                <ul>
                    <li class="radio_wrap">
                        <span>입출고</span>
                        <label>
                            <input type="radio" :checked="state.type === 1" @click="state.type = 1" />
                            <em></em>
                            <span>입고</span>
                        </label>

                        <label>
                            <input type="radio" :checked="state.type === 2" @click="state.type = 2" />
                            <em></em>
                            <span>출고</span>
                        </label>
                    </li>

                    <li v-if="state.type === 1">
                        <span>적재장소</span>
                        <input type="text" placeholder="적재장소 입력해주세요." v-model="state.place" />
                    </li>
                    <li v-else-if="state.type === 2">
                        <span>사용처</span>
                        <input type="text" placeholder="사용처 입력해주세요." v-model="state.location" />
                    </li>

                    <li>
                        <span>수량</span>
                        <input type="number" placeholder="수량을 입력해주세요." v-model="state.cnt" />
                    </li>
                </ul>

                <div class="btn_wrap">
                    <button class="submit_btn _gray" @click="closeModal">닫기</button>
                    <button class="submit_btn" @click="callbackFun">확인</button>
                </div>
            </div>
        </template>
    </div>
    <!-- 팝업 -->
</template>
<script lang="ts" config>
    import { reactive, onMounted, onUnmounted, watch, CommonUtils } from "@/BaseComponent";

    export default {
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        emits: ["close", "callback"],
        components: {},
        setup(props: any, { emit }: any) {
            const state = reactive({
                data: {} as any,

                idx: 0 as number,
                type: 1 as 1 | 2,
                place: "" as string,
                location: "" as string,
                cnt: 0 as number,
            });

            onMounted(() => {
                state.data = props.data;

                if (props.data) {
                    state.idx = props.data.idx;
                    state.type = props.data.type;

                    if (state.type === 1) {
                        state.place = props.data.place;
                    } else if (state.type === 2) {
                        state.location = props.data.location;
                    }
                    state.cnt = props.data.cnt;
                }

                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            watch(props, () => {
                state.data = props.data;

                if (props.data.name) {
                    state.idx = props.data.idx;
                    state.type = props.data.type;
                    if (state.type === 1) {
                        state.place = props.data.place;
                    } else if (state.type === 2) {
                        state.location = props.data.location;
                    }
                    state.cnt = props.data.cnt;
                } else {
                    state.idx = 0;
                    state.type = 1;
                    state.place = "";
                    state.location = "";
                    state.cnt = 0;
                }
            });

            const closeModal = () => {
                emit("close");
            };

            const callbackFun = () => {
                emit("callback", state);
            };

            const validateCheck = (text: string): boolean => {
                if (!text) {
                    return true;
                } else {
                    if (!CommonUtils.regexForPassword.test(text)) {
                        return true;
                    }
                }

                return false;
            };

            return { state, closeModal, callbackFun, validateCheck };
        },
    };
</script>

<style scoped>
    .content_wrap {
        margin-top: 20px;
    }
    .content_wrap ul li {
        display: flex;
        margin-bottom: 20px;
        align-items: center;
    }
    .content_wrap ul li > span {
        min-width: 80px;
        margin-right: 20px;
        text-align: right;
    }

    .content_wrap ul li > input {
        display: block;
        width: 100%;

        font-family: Noto Sans KR;
        font-weight: 400;
        font-size: 16px;

        text-align: left;
        height: 30px;
        background: #F7F7F9;
        border: 0;
    }
    .content_wrap ul li > input[type=number]{
        width: auto;
    }
    .content_wrap .file_wrap label {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        align-items: stretch;

        font-family: Noto Sans KR;
        font-weight: 400;
        font-size: 16px;
        
        line-height: 100%;
        text-align: left;
    }

    .content_wraprap input[type="file"] {
        display: none;
    }

    .content_wrap .file_box_wrap {
        flex: calc(100% - 150px);
        height: auto;
        border: 1px solid #d6d6d6;
        border-radius: 5px;
        line-height: 1.5;
        padding: 7px 10px;
        color: #6d6d6d;
        font-weight: 500;
    }

    .content_wrap .file_wrap .form_li_tit {
        min-width: 110px;
        letter-spacing: -0.5px;
        font-weight: 500;
        display: inline-block;
        color: #000;
    }

    .content_wrap .file_wrap .blue_btn {
        width: 140px;
        margin-left: 7px;
        height: auto;
    }

    .content_wrap .file_list {
        padding-left: 0;
        display: flex;
        gap: 15px;
        margin-top: 7px;
        flex-wrap: wrap;
    }

    .content_wrap .file .file_name {
        text-decoration: underline;
        color: #434343;
        transition: 0.2s;
    }

    .content_wrap .file .file_del {
        width: 18px;
        height: 18px;
        vertical-align: middle;
        display: inline-block;
        margin-left: 1px;
        margin-top: -3px;
        transition: 0.2s;
    }

    .content_wrap .file .file_del:hover {
        filter: brightness(1.15);
        transition: 0.2s;
    }

    .file_img {
    }
</style>
